export const DELETE_LESSON = 'delete-lesson';
export const ASSIGN_LESSON = 'assign-lesson';
export const CLOSE_ASSIGN_LESSON_DIALOG = 'close-assign-lesson-dialog';
